import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import servicesData from "../data/servicesData";
import countries from "../data/countries";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Services() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const showData = servicesData.map((el, index) =>
        <div key={index} className="js-scroll fade-top w-100 w-[31%] h-[380px] p-[25px] border-[1px] border-[#eee] flex flex-col justify-between gap-[10px]">
            <div>
                <img src={el.icon} alt="" />
            </div>
            <div className="font-bold text-[22px] border-b-4 border-[#b39359] w-fit">{t(`${el.title}`)}</div>
            <div className="text-[14px]">{t(`${el.details}`)}</div>
            <div className="flex items-center justify-between">
                <Link className="bg-[#B39359] text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/contact"}>{t("Call us now")}</Link>
                <div>
                    <img className="w-[25px] h-[25px]" src={el.number} alt="" />
                </div>
            </div>
        </div>)
    return (
        <>
            <section className="services-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">{t("What We Offer")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="f-col gap-res-20 container flex flex-wrap justify-center">
                    {showData}
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container">
                    <div className="w-100 flex mx-auto w-[75%] flex-col gap-[5px] items-center justify-center text-center">
                        <div className="js-scroll fade-top font-bold text-[25px] capitalize">{t("You can get a free consultation now")}</div>
                        <p className="js-scroll fade-btm">
                            {t("Fill in the fields and you will be contacted as soon as possible.")}
                        </p>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container">
                    <form action="https://ligasos.co/send_services.php" method="POST">
                        <div className="flex flex-col gap-[15px]">
                            <div className="f-col flex gap-[20px]">
                                <div className="w-100 w-[48%] flex flex-col gap-[10px]">
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("First Name")}</label>
                                        <input name="first_name" className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" type="text" placeholder={t("First Name")} required />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Email")}</label>
                                        <input name="email" className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" type="email" placeholder={t("Email")} required />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Type Of Service")}</label>
                                        <select name="service_type" className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" required>
                                            <option value="" disabled selected>{t("Select Type Of Service")}</option>
                                            <option value="property-sales">{t("Property Sales")}</option>
                                            <option value="property-rentals">{t("Property Rentals")}</option>
                                            <option value="property-management">{t("Property Management")}</option>
                                            <option value="investment-consultancy">{t("Investment Consultancy")}</option>
                                            <option value="real-estate-valuation">{t("Real Estate Valuation")}</option>
                                            <option value="legal-assistance">{t("Legal Assistance")}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="w-100 w-[48%] flex flex-col gap-[10px]">
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Last Name")}</label>
                                        <input name="last_name" className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" type="text" placeholder={t("Last Name")} required />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Phone Number")}</label>
                                        <input name="phone" className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" type="text" placeholder={t("Phone Number")} required />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("Your Place Of Residence")}</label>
                                        <select name="residence" className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px] text-black" required>
                                            <option value="">{t("Select Your Country")}</option>
                                            {countries.map((country,index) => (
                                                <option className="text-black" key={index} value={country.name.common}>
                                                    {country.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="w-[100%] flex flex-col gap-[7px]">
                                <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">{t("More Details")}</label>
                                <textarea name="details" className="h-[250px] max-h-[350px] js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]" placeholder={t("More Details")}></textarea>
                            </div>
                            <button type="submit" className="js-scroll fade-btm w-fit bg-[#132A40] text-white px-[40px] py-[8px] rounded font-bold capitalize">{t("send")}</button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}